module.exports = __webpack_public_path__ + "img/cone.7aeb32f7.png";